<template>
	<div class="comp">
		<div class="compContent">
			<div class="content">
				<div class="con">
					<div class="searchLine">
						<div class="searchLineL">
							<el-input style="width:180px;margin-right: 10px;" placeholder="请输入顾客名称或手机号" v-model="search.keyword" @keyup.enter.native="clickSearch" clearable size="small"></el-input>
							<el-button @click="clickSearch" type="warning" size="small">搜索</el-button>
							<div class="searchLabel">是否出库</div>
							<el-select style="width:130px" v-model="search.isEnter" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:0},{label:'已出库',value:1},{label:'未出库',value:2}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
							<div class="searchLabel">是否支付</div>
							<el-select style="width:130px" v-model="search.isPay" @change="changeSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:-1},{label:'已支付',value:1},{label:'未支付',value:0}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="searchLineR"></div>
					</div>
					<div class="elTable">
						<el-table :data="tableData" style="width: 100%" height="100%">
							<el-table-column label="单号" prop="id" width="160">
							</el-table-column>
							<el-table-column label="顾客" prop="memberName" min-width="100">
							</el-table-column>
							<el-table-column label="宠物昵称" prop="petName" min-width="120">
							</el-table-column>
							<el-table-column label="类别" min-width="80">
							</el-table-column>
							<el-table-column label="套餐名称" min-width="220" prop="medicalServiceName">
							</el-table-column> 
							<el-table-column label="创建时间" min-width="150">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.createTime)}}</div>
								</template>
							</el-table-column>
							<el-table-column label="医生" prop="doctorName" min-width="80">
							</el-table-column>
							<el-table-column label="支付状态" min-width="80">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isPay">已支付</div>
									<div style="color:#FD4E4E" v-else>未支付</div>
								</template>
							</el-table-column>
							<el-table-column label="是否出库" min-width="80">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isOut">已出库</div>
									<div style="color:#B7B7B7" v-if="props.row.isOut===false">未出库</div>
								</template>
							</el-table-column>
							<el-table-column label="备注" prop="remark" min-width="100">
							</el-table-column>
							<el-table-column label="操作" min-width="90">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="toEdit(props.row)" v-if="props.row.isPay">出库</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="pageBox">
					<page style="padding:10px 0;" :total="page.total" :page="page.page" @change="changePage"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				search:{
					keyword:'',
					isPay:-1,
					isEnter:0
				},
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			yaofangParams(){
				return this.$store.state.yiliaoxin.yaofangParams;
			},
		},
		created(){
			this.page.page = Number(sessionStorage.getItem('ylfwPage'))||1
		},
		mounted(){
			this.search = this.yaofangParams.initialDataOflist_ylfw.search||this.search;
			this.page = this.yaofangParams.initialDataOflist_ylfw.page||this.page;
			this.getTableData();
		},
		methods: {
			toEdit(row){
				this.yaofangParams.curRow = row
				this.yaofangParams.type = 'edit'
				this.$store.commit("yiliaoxin/set_yaofangParams",this.yaofangParams)
				this.$store.commit("yiliaoxin/add_router",{name:'药房',data:this.yaofangParams})
			},
			toSee(row){
				this.yaofangParams.curRow = row
				this.yaofangParams.type = 'see'
				this.$store.commit("yiliaoxin/set_yaofangParams",this.yaofangParams)
				this.$store.commit("yiliaoxin/add_router",{name:'药房',data:this.yaofangParams})
			},
			// reset(){
			// 	this.search.status=0;
			// 	this.search.isPay=-1;    // 是否支付
			// 	this.search.keyword='';
			// 	this.page.page=1;
			// 	this.getTableData()
			// },
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变筛选条件
			changeSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				sessionStorage.setItem('ylfwPage',num)
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let loading=this.$loading();
				let params = {
					"payType": 0, // 1全额；2消费卡
					"isPay": this.search.isPay,  // -1全部；0未支付；1已支付  
					"isOut": this.search.isEnter,        // 是否录入     0 1 2
					hasGoods:true,
					"petType": "",    // 猫类；犬类
					"petId": "",
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": this.search.keyword
				}
				this.$http.post('/api/MedicalService/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.yaofangParams.initialDataOflist_ylfw = {
					search:this.search,
					page:this.page,
				}
				this.$store.commit("yiliaoxin/set_yaofangParams",JSON.parse(JSON.stringify(this.yaofangParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'药房',data:JSON.parse(JSON.stringify(this.yaofangParams))})
			},
		},
		// beforeDestroy(){
		// 	this.yaofangParams.initialDataOflist_ylfw = {
		// 		search:this.search,
		// 		page:this.page,
		// 	}
		// 	this.$store.commit("yiliaoxin/set_yaofangParams",JSON.parse(JSON.stringify(this.yaofangParams)))
		// },
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				position: relative;display: flex;padding:0px 0 50px;width:100%;height: 100%;box-sizing: border-box;
				.con{
					width:100%;
					.tabLine{
						height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
						.tabLineL{
							display: flex;
							.tabItem{
								width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
								font-weight: bold;
								&.active{
									color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
								}
							}
						}
						.tabLineR{
							
						}
					}
					.searchLine{
						padding:8px 20px 20px;box-sizing: border-box;display: flex;
						.searchLineL{
							display: flex;
							.searchLabel{
								font-size: 14px;margin-right: 5px;color:$fontColor;line-height:32px;margin-left:10px;
							}
						}
						.searchLineR{
							
						}
					}
					.elTable{
						height: calc(100% - 60px);
					}
				}
				.pageBox{
					position: absolute;bottom:0;width:100%;
				}
			}
		}
	}
</style>
